<template>
	<div class="w5-error-alert">
		<div class="alert alert-danger" role="alert">
			<p style="padding:0;margin:0;" v-withSafeTags="localeFtc(message)"></p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'errorAlert',
	props: ['message']
}
</script>

<style scoped>
.w5-error-alert {
	margin: 20px 0;
	font-size: 90%;
	text-align: center;
	width: 100;
}
</style>



// WEBPACK FOOTER //
// errorAlert.vue?11037bb7